import React, { useState, useEffect, useRef } from "react";
import { Icons } from "./icons.jsx";
import { LiveDot } from "./primitives.jsx";
import {
  CallModalRoot,
  CallModalHeader,
  CallModalHeaderLeft,
  CallModalLiveLabel,
  CallModalProgramTitle,
  CallModalVideoWrap,
  CallModalVideoBg,
  CallModalVideoEl,
  CallModalVideoGradient,
  CallModalGuruInfo,
  CallModalGuruName,
  CallModalGuruRole,
  CallModalControls,
  CallModalInputRow,
  CallModalInput,
  CallModalSendBtn,
  CallModalEndWrap,
  CallModalEndBtn,
  CallModalEndLabel,
} from "./style.js";
import { useStartDemoSimulation } from "./useMarketplace.js";

// ── CallModal (Guru call screen) ──────────────────────────────────────────────
const CallModal = ({ program, onClose, onSimulationStarted }) => {
  const videoRef = useRef(null);
  const [question, setQuestion] = useState("");
  const demoMutation = useStartDemoSimulation();

  // Auto-start the demo simulation when the modal opens
  useEffect(() => {
    if (program?.demo_scenario_id && !demoMutation.data && !demoMutation.isPending) {
      demoMutation.mutate(program.id, {
        onSuccess: (data) => {
          onClose();
          onSimulationStarted?.(data);
        },
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!program) return null;
  const [accentStart, accentEnd] = program.accent ?? ["#01ECFF", "#962EFF"];

  return (
    <CallModalRoot>
      {/* Header */}
      <CallModalHeader>
        <CallModalHeaderLeft>
          <LiveDot />
          <CallModalLiveLabel>
            Live with {program.guru?.full_name.split(" ")[0]}
          </CallModalLiveLabel>
        </CallModalHeaderLeft>
        <CallModalProgramTitle>{program.name}</CallModalProgramTitle>
      </CallModalHeader>

      {/* Guru video */}
      <CallModalVideoWrap>
        <CallModalVideoBg $a={accentStart} $b={accentEnd} />
        <CallModalVideoEl
          ref={videoRef}
          src={program.intro_video_url}
          autoPlay
          muted
          loop
          playsInline
        />
        <CallModalVideoGradient />
        <CallModalGuruInfo>
          <CallModalGuruName>{program.guru?.full_name}</CallModalGuruName>
          <CallModalGuruRole>{program.guru?.role}</CallModalGuruRole>
        </CallModalGuruInfo>
      </CallModalVideoWrap>

      {/* Bottom controls */}
      <CallModalControls>
        {/* Question input */}
        <CallModalInputRow>
          <CallModalInput
            placeholder={`Ask ${program.guru?.full_name.split(" ")[0]} about ${program.name}…`}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
          <CallModalSendBtn>
            <Icons.arrowRight size={18} style={{ color: "#01ECFF" }} />
          </CallModalSendBtn>
        </CallModalInputRow>
        {/* End call */}
        <CallModalEndWrap>
          <CallModalEndBtn onClick={onClose}>
            <Icons.phone
              size={24}
              style={{ color: "#fff", transform: "rotate(135deg)" }}
            />
          </CallModalEndBtn>
          <CallModalEndLabel>End call</CallModalEndLabel>
        </CallModalEndWrap>
      </CallModalControls>
    </CallModalRoot>
  );
};

export default CallModal;
